import React from 'react';
import { URL as API_URL } from '../../../env';

// The Kestrel Logistics deal workspace is a standalone vanilla-JS app, served as a static file from
// /demos/ (copied into dist by the `build`/`start` npm scripts, never bundled by Parcel).
//
// Reason: it must run in an iframe, not inline. It owns `location.hash` for its own routing, calls
// window.scrollTo(0,0) on every render, writes `document.documentElement.dataset.theme`, and defines
// ~30 globals wired through inline onclick attributes. The iframe gives it its own document, hash,
// scroll position and global scope, so none of that can reach the landing page — and its 460 lines
// of CSS cannot collide with the utility classes.
// The sandbox's lead-capture gate posts to the Diligentsia API, which sits on a different origin in
// every environment. Passing the base in as ?api=… keeps that environment logic in env.js only —
// the query string must precede the hash, which the demo's own router owns.
const DEMO_SRC = `/demos/kestrel-demo.html?api=${encodeURIComponent(API_URL)}#/pipeline`;

const SandboxSection = () => (
    <section className="lp-demo-section" id="try-the-demo">
        <div className="lp-demo-head">
            <span className="lp-demo-eyebrow" data-lp-reveal>Try it yourself</span>
            <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ fontSize: '34px', fontWeight: '600' }}>This is the platform your applicants land in — try it live</h2>
            <p className="lp-sub" data-lp-reveal data-lp-delay="120" style={{ fontSize: '15px' }}>
                Below is Diligentsia's actual deal workspace, loaded with a real sample application — <strong>Kestrel Logistics</strong>,
                a seed-stage logistics SaaS company — moving through intake, AI analysis, triage, diligence, stress-testing and the IC memo.
                Click through the pipeline exactly as your team would.
            </p>
        </div>

        <div className="lp-demo-shell" data-lp-reveal data-lp-delay="160">
            <div className="lp-demo-bar">
                <span className="lp-demo-dot" /><span className="lp-demo-dot" /><span className="lp-demo-dot" />
                <span className="lp-demo-url">app.diligentsia.co.uk/pipeline</span>
                <span className="lp-demo-badge">● Sample data — Kestrel Logistics</span>
            </div>
            <iframe
                className="lp-demo-iframe"
                src={DEMO_SRC}
                title="Diligentsia deal management demo — Kestrel Logistics"
                loading="lazy"
            />
        </div>

        <p className="lp-demo-footnote">This is a live interactive sandbox — nothing you click here affects real data. Book a call to see it running on your own pipeline.</p>
    </section>
);

export default SandboxSection;
